var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container container--mobile" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("Pagination", {
                    attrs: { numberOfDots: 4, numberOfVisitedDots: 4 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-top-75" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-wrapper" }, [
                    _c("h1", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.verifygentestheader
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.screening.verifygentesttext)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("router-link", { attrs: { to: "/verifyfacility" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-lg btn-block",
                        class:
                          _vm.previousanswer !== "" &&
                          _vm.previousanswer !== "Nej" &&
                          _vm.previousanswer !== "Vet ej"
                            ? "previous-answer"
                            : ""
                      },
                      [_vm._v("\n            Ja\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block",
                      class:
                        _vm.previousanswer === "Nej" ? "previous-answer" : "",
                      on: {
                        click: function($event) {
                          return _vm.verifyGenTest("Nej")
                        }
                      }
                    },
                    [_vm._v("Nej")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block",
                      class:
                        _vm.previousanswer === "Vet ej"
                          ? "previous-answer"
                          : "",
                      on: {
                        click: function($event) {
                          return _vm.verifyGenTest("Vet ej")
                        }
                      }
                    },
                    [_vm._v("Vet ej")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v("← Tillbaka")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27ce535c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ce535c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyGeneticTest.vue
// module id = null
// module chunks = 